import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { InsCommentList_comments_edges_node } from "@saleor/inscomment/types/InsCommentList";
import { InsCommentListUrlSortField } from "@saleor/inscomment/urls";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SearchPageProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import InsCommentList from "../InsCommentList/InsCommentList";
import {
  createFilterStructure,
  InsCommentFilterKeys,
  InsCommentListFilterOpts
} from "./filters";

export interface InsCommentListPageProps
  extends PageListProps,
    SearchPageProps,
    ListActions,
    SortPage<InsCommentListUrlSortField>,
    FilterPageProps<InsCommentFilterKeys, InsCommentListFilterOpts>,
    TabPageProps {
  comments: InsCommentList_comments_edges_node[];
  onVisibleUpdate: (id: string) => void;
  toatlCount: number;
}

const InsCommentListPage: React.FC<InsCommentListPageProps> = ({
  initialSearch,
  onAdd,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  filterOpts,
  currencySymbol,
  onFilterChange,
  ...listProps
}) => {
  const intl = useIntl();
  const filterStructure = createFilterStructure(intl, filterOpts);
  return (
    <Container>
      <PageHeader
        title={
          intl.formatMessage(sectionNames.commentList) + "(" + toatlCount + ")"
        }
      ></PageHeader>
      <Card>
        <FilterBar
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          initialSearch={initialSearch}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          tabs={tabs}
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Comments",
            description: "tab name"
          })}
          filterStructure={filterStructure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Comments..."
          })}
        />
        <InsCommentList {...listProps} />
      </Card>
    </Container>
  );
};

export default InsCommentListPage;
